
import * as storyblokRuntime$zqnhMOtUXF from '/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxStaticRuntime$IZlKML1e7t from '/Users/id30-cyrus/Documents/Codex/iD30/EPC - Solar Landing Page v3/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536,
    "narrow": 1000,
    "1xl": 1300,
    "normal": 1400,
    "3xl": 1620,
    "wide": 1800
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 75
}

imageOptions.providers = {
  ['storyblok']: { provider: storyblokRuntime$zqnhMOtUXF, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipxStatic']: { provider: ipxStaticRuntime$IZlKML1e7t, defaults: {} }
}
        